// extracted by mini-css-extract-plugin
export default {"upload":"Modal_upload__ZhP-O","uploadBtn":"Modal_uploadBtn__bZBJz"};